/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentValidationRequest {
    getFixupPrototypeFunction() { return AssessmentValidationRequest.fixupPrototype; }

    static newInstance(model: Partial<AssessmentValidationRequest>): AssessmentValidationRequest {
        let obj = Object.assign(new AssessmentValidationRequest(), model);
        AssessmentValidationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentValidationRequest>): AssessmentValidationRequest {
        if (!model) return null;
        return AssessmentValidationRequest.newInstance(<AssessmentValidationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentValidationRequest) {
        if (!obj) return;

        models.AssessmentValidationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentValidationRequest): boolean {
        Object.setPrototypeOf(obj, AssessmentValidationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Account Id
     */
    cloud_account_id: string;

    /**
     * Name of the category
     */
    category: models.AssessmentCategory;

    /**
     * Type of Validation
     */
    validation_type: string;

}
